import {cs}               from "@Common/react/chain-services";
import {Static2}          from "@Common/react/static-2";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";

import {ShippingQuantity} from "@Xpresso/routes/common/heavy/shipping-quantity/shipping-quantity";

import {ScQuantityLogic} from "../common/sc-quantity-logic";

export const ScShippingQuantity = ({initEnrollment, enabled, next: rootNext}) => cs(
    ["logic", (_, next) => ScQuantityLogic({
        path: ["distribution_options", "shipping", "quantity"],
        defaultValue: 25,
        initEnrollment, enabled,
        next,
    })],
    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    ["step1", ({logic}, next) => rootNext({
        quantity: !enabled ? null : logic.state.value,
        next,
    })],
    ({logic, domRef, eh, step1}) => step1.next({
        // ui:
        enrollmentEditor: !enabled ? logic.clearEnrollmentEditor : {
            ...logic.enrollmentEditor,
            valid: !!step1.paperPrice,
            errorsHandling: {
                highlightErrors: () => {
                    eh.start();
                    scrollIntoView(domRef.get());
                },
            },
        },
        ui: !enabled ? null : (({showErrors}) => ShippingQuantity({
            state: logic.state,
            domRef: domRef.set,
            eh,
            hidePricing: true,
            paperPrices: step1.paperPrices,
            showErrors,
            paperPrice: step1.paperPrice,
        })),
    })
);
